import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
// import { DaterangePickerComponent, DaterangepickerConfig} from 'ng2-daterangepicker';
import {ValidatorUtils} from '../../shared/utils/src/validator.utils';

@Component({
    selector: 'app-time-picker',
    templateUrl: 'timepicker.component.html',
})
export class TimepickerComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    @Input() time: string;
    @Input() rsrcId: string;
    @Output() timeChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() setTimes: EventEmitter<any> = new EventEmitter<any>();

    preTime = '';
    timePickerOption: any = {};
    timePickerId = '_timePicker_';

    // constructor(private daterangepickerOptions: DaterangepickerConfig) {
    //     // datepicker calendar global settings
    //     this.daterangepickerOptions.skipCSS = true;
    // }

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(): void {
        if (this.rsrcId !== undefined) {
            this.timePickerId += this.rsrcId;
        }
        this.preTime = this.time;
    }

    ngAfterViewInit() {
        // timepicker 초기화
        this.initTimePicker();

        // create timepicker
        $('#' + this.timePickerId).timepicker(this.timePickerOption);

        const _x = this;
        $('#' + this.timePickerId).on('changeTime', function() {
            console.log('타임 변경: ', $(this).val());
            _x.timeChange.emit($(this).val());
        });
    }

    ngOnDestroy() {
        $('#' + this.timePickerId).timepicker('remove');
    }

    initTimePicker() {
        this.timePickerOption = {
            timeFormat: 'H:i',
            show2400: true,
            scrollDefault: 'now',
            minTime: '00:00',
            maxTime: '23:59',
            step: 30
        };
    }

    onTimeChange(event: any) {
        if (event.type === 'keydown') {
            return ValidatorUtils.onlyTime(event);
        } else {
            if (ValidatorUtils.checkTime(event.target.value)) {
                this.preTime = this.time = event.target.value;
            } else {
                this.time = this.preTime;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/timepicker/timepicker.component.ts